export const addHostToHmcUrls = (host, object, properties = [
  'categoryProductConfiguratorUrl',
  'rangeTooltipUrl',
  'questionnaireUrl',
  'selectorConfigUrl',
]) => {
  properties.forEach((property) => {
    var _a, _b;
    if (!((_b = (_a = object[property]) === null || _a === void 0 ? void 0 : _a.startsWith) === null || _b === void 0 ? void 0 : _b.call(_a, '/')))
      return;
    const hostWithLocale = `${host}${(object[property].startsWith('/zh/') ? 'cn' : '')}`;
    object[property] = `${hostWithLocale}${object[property]}`;
  });
};
